'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = handleFileInfo;

var _getFileDetail2 = require('./getFileDetail');

var _getFileDetail3 = _interopRequireDefault(_getFileDetail2);

var _createThumbnail = require('./createThumbnail');

var _createThumbnail2 = _interopRequireDefault(_createThumbnail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * handle single file and get file info
 *
 * @param file
 * @param quality
 * @param callback
 */
function handleFileInfo(_ref, callback) {
  var file = _ref.file,
      quality = _ref.quality,
      maxWidth = _ref.maxWidth,
      maxHeight = _ref.maxHeight;

  var _getFileDetail = (0, _getFileDetail3.default)(file),
      fileSize = _getFileDetail.fileSize,
      fileType = _getFileDetail.fileType,
      isPic = _getFileDetail.isPic,
      fileName = _getFileDetail.fileName;

  var fileDetail = {
    file: file,
    fileType: fileType,
    fileSize: fileSize,
    fileName: fileName
  };

  var callbackFunc = function callbackFunc(url) {
    fileDetail.thumbnail = url;

    callback(fileDetail);
  };

  if (isPic) {
    (0, _createThumbnail2.default)({
      file: file,
      quality: quality,
      fileType: fileType,
      maxWidth: maxWidth,
      maxHeight: maxHeight
    }, callbackFunc);
  } else {
    callback(fileDetail);
  }
}